import React, { FC, useState } from 'react';

const As2StatusGuide: FC = () => {
    const [open, setOpen] = useState(false);

    return (
        <div className="rounded-md border border-slate-200 bg-slate-50 text-sm text-slate-700">
            <button
                type="button"
                className="flex w-full items-center justify-between px-3 py-2 font-medium text-slate-800 hover:bg-slate-100"
                onClick={() => setOpen((v) => !v)}
            >
                AS2 message status guide
                <span className="text-xs text-slate-500">{open ? 'Hide' : 'Show'}</span>
            </button>
            {open && (
                <div className="space-y-3 border-t border-slate-200 px-3 py-3">
                    <p className="text-sm text-slate-600">
                        Outbound messages are sent automatically on every shipment (if AS2 is enabled).
                        Inbound messages from partners must be reviewed and approved before EPCIS data is imported.
                        OpenAS2 handles the actual AS2 protocol — Spring Boot only manages file queues and DB records.
                    </p>
                    <table className="w-full text-left text-xs">
                        <thead>
                            <tr className="border-b border-slate-200 text-slate-500">
                                <th className="py-1 pr-3">Status</th>
                                <th className="py-1 pr-3">Direction</th>
                                <th className="py-1 pr-3">MDN</th>
                                <th className="py-1">What admin should do</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            <tr>
                                <td className="py-1.5 pr-3 font-medium">PENDING</td>
                                <td className="py-1.5 pr-3 text-indigo-700">Outbound</td>
                                <td className="py-1.5 pr-3">—</td>
                                <td className="py-1.5">File being written to outbox. Wait 10s for OpenAS2 to pick it up.</td>
                            </tr>
                            <tr>
                                <td className="py-1.5 pr-3 font-medium">DISPATCHED</td>
                                <td className="py-1.5 pr-3 text-indigo-700">Outbound</td>
                                <td className="py-1.5 pr-3">PENDING</td>
                                <td className="py-1.5">OpenAS2 is transmitting. If stuck more than 5 min, check OpenAS2 logs.</td>
                            </tr>
                            <tr>
                                <td className="py-1.5 pr-3 font-medium">SENT</td>
                                <td className="py-1.5 pr-3 text-indigo-700">Outbound</td>
                                <td className="py-1.5 pr-3">PENDING</td>
                                <td className="py-1.5">File transmitted. Waiting for sync MDN from partner.</td>
                            </tr>
                            <tr>
                                <td className="py-1.5 pr-3 font-medium text-green-700">MDN_RECEIVED</td>
                                <td className="py-1.5 pr-3 text-indigo-700">Outbound</td>
                                <td className="py-1.5 pr-3 text-green-700">PROCESSED ✓</td>
                                <td className="py-1.5 text-green-700">Partner confirmed receipt. DSCSA compliance obligation met.</td>
                            </tr>
                            <tr>
                                <td className="py-1.5 pr-3 font-medium text-red-700">FAILED (MDN)</td>
                                <td className="py-1.5 pr-3 text-indigo-700">Outbound</td>
                                <td className="py-1.5 pr-3 text-red-700">FAILED</td>
                                <td className="py-1.5 text-red-700">
                                    Partner returned an error disposition (e.g. decryption or signature failure).
                                    Open Detail for the disposition text, fix cert/URL/config, then Retry.
                                </td>
                            </tr>
                            <tr>
                                <td className="py-1.5 pr-3 font-medium text-red-700">FAILED</td>
                                <td className="py-1.5 pr-3 text-indigo-700">Outbound</td>
                                <td className="py-1.5 pr-3 text-red-700">FAILED</td>
                                <td className="py-1.5 text-red-700">Open Detail → check error → click Retry. Check partner status.</td>
                            </tr>
                            <tr>
                                <td className="py-1.5 pr-3 font-medium text-amber-700">AWAITING_ADMIN_INPUT</td>
                                <td className="py-1.5 pr-3 text-purple-700">Inbound</td>
                                <td className="py-1.5 pr-3">N/A</td>
                                <td className="py-1.5 text-amber-800">Open Detail → read EPCIS XML → Approve or Reject.</td>
                            </tr>
                            <tr>
                                <td className="py-1.5 pr-3 font-medium">SENT (inbound)</td>
                                <td className="py-1.5 pr-3 text-purple-700">Inbound</td>
                                <td className="py-1.5 pr-3">N/A</td>
                                <td className="py-1.5">Admin approved. EPCIS import triggered.</td>
                            </tr>
                            <tr>
                                <td className="py-1.5 pr-3 font-medium text-red-700">ADMIN_REJECTED</td>
                                <td className="py-1.5 pr-3 text-purple-700">Inbound</td>
                                <td className="py-1.5 pr-3">N/A</td>
                                <td className="py-1.5">Closed — admin rejected. No further processing.</td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="text-xs text-slate-500 pt-1">
                        MDN (Message Disposition Notification) = a receipt the partner sends back to confirm they received and decrypted our EPCIS document.
                        It contains a cryptographic hash (MIC) that proves the content was not tampered with.
                    </p>
                </div>
            )}
        </div>
    );
};

export default As2StatusGuide;
